export default __webpack_public_path__ + "static/media/airplane_avion_1.1510aaab.png";